import 'swiper/css'

import { Autoplay } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { recognitionSection } from "../../utilities/newSectionData"
import { useDispatch, useSelector } from "react-redux"
import { selectLogoDetails, setRecognisedSectionModalDetails, setShowRecognisedSection } from "../../redux/addOnSlice"
import useWindowSize from "../../hooks/useWindowSize"
import { useEffect, useMemo, useRef, useState } from "react"
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../../utilities/constants'

const SLIDE_SPEED = 2500

const NewRecognisedSection = ({ setSwiperInstance, swiperInstance }) => {

    const logosAndSalary = useSelector(selectLogoDetails)

    const [ glowSlide, setGlowSlide ] = useState(null)

    const glowTimeoutRef = useRef(null)
    const initialGlowTimeoutRef = useRef(null)

    const dispatch = useDispatch()
    const { width } = useWindowSize()

    useEffect(() => {
        initialGlowTimeoutRef.current = setTimeout(() => {
            setGlowSlide(0)
            setTimeout(() => {
                setGlowSlide(null)
            }, 1100)
        }, SLIDE_SPEED)
      
        return () => {
            if (initialGlowTimeoutRef.current) clearTimeout(initialGlowTimeoutRef.current)
        }
    }, [])

    const handleSlideChange = (swiper) => {
      
        if (initialGlowTimeoutRef.current) {
            clearTimeout(initialGlowTimeoutRef.current)
            initialGlowTimeoutRef.current = null
        }
      
        if (glowTimeoutRef.current) {
            clearTimeout(glowTimeoutRef.current)
        }
      
        glowTimeoutRef.current = setTimeout(() => {
            setGlowSlide(swiper.realIndex)
        
            setTimeout(() => {
                setGlowSlide(null)
            }, 1100)
        }, SLIDE_SPEED)
    }

    const handleModal = (item, originalIndex) => {
        if(swiperInstance){
            swiperInstance?.autoplay?.stop()
        }
        Mixpanel.track(constants.Mixpanel.ANALYSIS_PAGE_RECOGNISED_SECTION_USER_DETAILS_MODAL_OPENED)
        dispatch(setRecognisedSectionModalDetails({ item, originalIndex }))
        dispatch(setShowRecognisedSection(true))
    }

    const chunks = useMemo(() => {
        function chunkArray(array, size = 8) {
            const result = []
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size))
            }
            return result
        }

        return chunkArray(recognitionSection, 8)
    }, [])
    
    return (
        <div className="w-[calc(100%+32px)] bg-[#0D2436] -ml-4 relative pt-10">
            <div className="absolute left-1/2 -translate-x-1/2 -top-3">
                <img src="https://ik.imagekit.io/238r9emirjj/recognised_section/Group%2020761.png?updatedAt=1745660796666" width={40} height={40} alt="" />
            </div>
            <div className="px-3">
                <h2 className="text-2xl text-center font-medium">Your Certificate is Recognised by <span className="font-bold text-[#00C1FF]">1100+Top Companies</span></h2>
            </div>
            <div className="pt-6 px-3">
                <p className="text-xs text-[#D3D8DE] font-light italic text-center mb-2"><img src="https://ik.imagekit.io/238r9emirjj/recognised_section/Frame%20427321172.png?updatedAt=1745670254977"width={24} height={11} className="image-inline transform scale-y-[-1]" alt="" />Tap  for Success Stories</p>
                <Swiper
                    onSwiper={setSwiperInstance}
                    spaceBetween={12}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false
                    }}
                    speed={2000}
                    modules={[Autoplay ]}
                    className="mySwiper"
                    onSlideChange={handleSlideChange}
                >
                    {chunks?.map((item, index) => {
                        return (<SwiperSlide key={index} className="w-full grid grid-cols-4 grid-rows-2 gap-2">
                            <div className="grid grid-cols-4 grid-rows-2 gap-4">
                                {item?.map((card, cardIndex) => {

                                    const originalIndex = index * 8 + cardIndex;

                                    return (<div className="p-[0.5px] rounded-lg sm:rounded-xl cursor-pointer" onClick={() => handleModal(card, originalIndex)}
                                        style={{
                                            backgroundImage: 'conic-gradient(from 180deg, rgba(253, 253, 253, 0) 36%, rgba(255, 255, 255, 0.6) 40%, rgba(251, 251, 251, 0.576) 61%, rgba(253, 253, 253, 0.042) 65%)'
                                        }}
                                    >
                                        <div 
                                            key={cardIndex} // you should add a key if possible
                                            className={`py-4 px-2 rounded-lg sm:rounded-xl bg-[#102941] ${glowSlide === index ? 'btn--glow' : ''}`}
                                            style={{
                                                backgroundImage: 'radial-gradient(circle, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 0.43) 40%, rgba(255, 255, 255, 0.36) 49%, rgba(255, 255, 255, 0.3) 59%, rgba(255, 255, 255, 0.18) 88%, rgba(255, 255, 255, 0.13) 100%)',
                                            }}
                                        >
                                            <img 
                                                src={card?.companyImage} 
                                                height={40} 
                                                width={60} 
                                                className={`mx-auto ${width <= 320 ? 'h-7' : width <= 360 ? 'h-8' : 'h-10'} w-auto`} 
                                                alt=""
                                                style={{
                                                    filter: 'drop-shadow(0px 0.5px 0px #424447) drop-shadow(0px 1px 0px #424447) drop-shadow(0px 1.5px 0px #424447) drop-shadow(0px 2px 0px #424447)',
                                                }}
                                            />
                                            <p className="text-xs font-semibold text-center truncate mt-2">{card?.finalOrgTitle}</p>
                                            <div className="mt-1.5">
                                                <img src={card?.profileImage} width={24} height={24} className="rounded-full border border-white mx-auto" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                )})}
                            </div>
                        </SwiperSlide>
                    )})}
                </Swiper>       
            </div>
            <div className="mt-8 px-3 pb-7">
                <div className="flex items-center gap-2 mb-4">
                    <div className="flex-1 border-b border-[#D5EDFF]" />
                    <h4 className="text-sm font-semibold text-[#D5EDFF]">Roles You Will Be Eligible For</h4>
                    <div className="flex-1 border-b border-[#D5EDFF]" />
                </div>
                <Swiper
                    spaceBetween={8}
                    slidesPerView={width <= 450 ? 2 : 3}
                    loop={true}
                    autoplay={{
                        delay: 0,
                        disableOnInteraction: false
                    }}
                    speed={5000}
                    loopFillGroupWithBlank={true}
                    modules={[ Autoplay ]}
                    className="mySwiper"
                    
                >
                    {logosAndSalary?.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className='rounded-lg p-3 bg-[#224064] min-h-[87px] flex justify-between'>
                                <div className="flex-1">
                                    <p className='text-sm font-semibold line-clamp-1'>{item?.company_name}</p>
                                    <h4 className='text-xxs text-[#B0C1CD] line-clamp-1'>{item?.role}</h4>
                                    <div className='mt-2 text-xxs flex items-center gap-1 text-[#83BEFF]'>
                                        <p className=''><span className=''>₹</span> <span className=''>{item?.salary?.replaceAll('lpa', '')}</span> LPA</p>
                                    </div>
                                </div>
                                {item?.logo && <div>
                                    <img 
                                        src={item?.logo} 
                                        height={20} 
                                        width={20} 
                                        className="max-h-[30px] max-w-[45px] md:max-w-[70px] md:max-h-[40px] opacity-60 object-contain object-center w-auto h-auto"
                                        style={{
                                            filter: 'saturate(0%) brightness(500%) contrast(0%)'
                                        }} 
                                        alt=""
                                    />
                                </div>}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default NewRecognisedSection